import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enabled", "description", "dataCy"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { Switch as ReactSwitch } from '@headlessui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Switch = function Switch(_ref) {
  var enabled = _ref.enabled,
      description = _ref.description,
      dataCy = _ref.dataCy,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(ReactSwitch.Group, {
    as: "div",
    className: "flex items-center gap-x-4",
    children: [/*#__PURE__*/_jsx(ReactSwitch.Description, {
      as: "span",
      className: "text-base text-black",
      children: description
    }), /*#__PURE__*/_jsx(ReactSwitch, _objectSpread(_objectSpread({
      "data-cy": dataCy,
      checked: enabled,
      className: classNames('relative inline-flex items-center flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200', {
        'bg-green-500': enabled,
        'bg-gray-200': !enabled
      })
    }, rest), {}, {
      children: /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        className: classNames('pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200', {
          'translate-x-5': enabled,
          'translate-x-1': !enabled
        })
      })
    }))]
  });
};